import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sv2-step" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Try Ditto free for 30 days", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "sv2-step__subtitle" }, "Tell us a bit about yourself to get started.", -1)
const _hoisted_4 = { class: "sv2-fields" }
const _hoisted_5 = { class: "sv2-field-row" }
const _hoisted_6 = { class: "sv2-field" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "sv2-field__label" }, [
  /*#__PURE__*/_createTextVNode("First Name"),
  /*#__PURE__*/_createElementVNode("span", { class: "sv2-field__required" }, "*")
], -1)
const _hoisted_8 = { class: "sv2-input-wrap" }
const _hoisted_9 = { class: "sv2-input-wrap__icon" }
const _hoisted_10 = {
  key: 0,
  class: "sv2-field__error"
}
const _hoisted_11 = { class: "sv2-field" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "sv2-field__label" }, [
  /*#__PURE__*/_createTextVNode("Last Name"),
  /*#__PURE__*/_createElementVNode("span", { class: "sv2-field__required" }, "*")
], -1)
const _hoisted_13 = {
  key: 0,
  class: "sv2-field__error"
}
const _hoisted_14 = { class: "sv2-field" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "sv2-field__label" }, [
  /*#__PURE__*/_createTextVNode("Email"),
  /*#__PURE__*/_createElementVNode("span", { class: "sv2-field__required" }, "*")
], -1)
const _hoisted_16 = { class: "sv2-input-wrap" }
const _hoisted_17 = { class: "sv2-input-wrap__icon" }
const _hoisted_18 = {
  key: 0,
  class: "sv2-field__error"
}
const _hoisted_19 = {
  key: 1,
  class: "sv2-field__error"
}
const _hoisted_20 = {
  key: 2,
  class: "sv2-field__error"
}
const _hoisted_21 = { class: "sv2-field" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "sv2-field__label" }, [
  /*#__PURE__*/_createTextVNode("Job Function"),
  /*#__PURE__*/_createElementVNode("span", { class: "sv2-field__required" }, "*")
], -1)
const _hoisted_23 = { class: "sv2-select-wrap" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Select function", -1)
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "sv2-select-wrap__caret" }
const _hoisted_27 = {
  key: 0,
  class: "sv2-field__error"
}
const _hoisted_28 = { class: "sv2-field" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "sv2-field__label" }, [
  /*#__PURE__*/_createTextVNode("Phone Number"),
  /*#__PURE__*/_createElementVNode("span", { class: "sv2-field__required" }, "*")
], -1)
const _hoisted_30 = { class: "sv2-input-wrap" }
const _hoisted_31 = { class: "sv2-input-wrap__icon" }
const _hoisted_32 = {
  key: 0,
  class: "sv2-field__error"
}
const _hoisted_33 = { class: "sv2-field" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "sv2-field__label" }, [
  /*#__PURE__*/_createTextVNode("Country"),
  /*#__PURE__*/_createElementVNode("span", { class: "sv2-field__required" }, "*")
], -1)
const _hoisted_35 = { class: "sv2-select-wrap" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Select country", -1)
const _hoisted_37 = ["value"]
const _hoisted_38 = { class: "sv2-select-wrap__caret" }
const _hoisted_39 = {
  key: 0,
  class: "sv2-field__error"
}
const _hoisted_40 = {
  key: 0,
  class: "sv2-field"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "sv2-field__label" }, [
  /*#__PURE__*/_createTextVNode("State"),
  /*#__PURE__*/_createElementVNode("span", { class: "sv2-field__required" }, "*")
], -1)
const _hoisted_42 = { class: "sv2-select-wrap" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Select state", -1)
const _hoisted_44 = ["value"]
const _hoisted_45 = { class: "sv2-select-wrap__caret" }
const _hoisted_46 = {
  key: 0,
  class: "sv2-field__error"
}
const _hoisted_47 = { class: "sv2-actions sv2-actions--end" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = {
  key: 0,
  class: "sv2-spinner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ph_user = _resolveComponent("ph-user")!
  const _component_ph_envelope_simple = _resolveComponent("ph-envelope-simple")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ph_caret_down = _resolveComponent("ph-caret-down")!
  const _component_ph_phone = _resolveComponent("ph-phone")!
  const _component_ph_arrow_right = _resolveComponent("ph-arrow-right")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, [
              _createVNode(_component_ph_user, {
                size: 16,
                weight: "fill"
              })
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.firstName) = $event)),
              class: _normalizeClass(["sv2-input sv2-input--icon", { 'sv2-input--error': _ctx.showErrors && !_ctx.form.firstName }]),
              placeholder: "Jane"
            }, null, 2), [
              [
                _vModelText,
                _ctx.form.firstName,
                void 0,
                { trim: true }
              ]
            ])
          ]),
          (_ctx.showErrors && !_ctx.form.firstName)
            ? (_openBlock(), _createElementBlock("p", _hoisted_10, "This field is required."))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.lastName) = $event)),
            class: _normalizeClass(["sv2-input", { 'sv2-input--error': _ctx.showErrors && !_ctx.form.lastName }]),
            placeholder: "Smith"
          }, null, 2), [
            [
              _vModelText,
              _ctx.form.lastName,
              void 0,
              { trim: true }
            ]
          ]),
          (_ctx.showErrors && !_ctx.form.lastName)
            ? (_openBlock(), _createElementBlock("p", _hoisted_13, "This field is required."))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("span", _hoisted_17, [
            _createVNode(_component_ph_envelope_simple, {
              size: 16,
              weight: "fill"
            })
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.email) = $event)),
            type: "email",
            class: _normalizeClass(["sv2-input sv2-input--icon", { 'sv2-input--error': (_ctx.showErrors && !!_ctx.emailError) || _ctx.emailBlocked }]),
            placeholder: "jane@company.com",
            onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleEmailBlur && _ctx.handleEmailBlur(...args)))
          }, null, 34), [
            [
              _vModelText,
              _ctx.form.email,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        (_ctx.showErrors && _ctx.emailError)
          ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.emailError), 1))
          : (_ctx.emailBlocked)
            ? (_openBlock(), _createElementBlock("p", _hoisted_19, "Please use your work or school email address."))
            : (_ctx.emailInUse)
              ? (_openBlock(), _createElementBlock("p", _hoisted_20, [
                  _createTextVNode(" An account with this email already exists. "),
                  _createVNode(_component_router_link, {
                    to: "/login",
                    style: {"color":"inherit","font-weight":"600"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Sign in")
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" or use a different email. ")
                ]))
              : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _createElementVNode("div", _hoisted_23, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.jobFunction) = $event)),
            class: _normalizeClass(["sv2-input", {
                            'sv2-select--placeholder': !_ctx.form.jobFunction,
                            'sv2-input--error': _ctx.showErrors && !_ctx.form.jobFunction
                        }])
          }, [
            _hoisted_24,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobFunctions, (j) => {
              return (_openBlock(), _createElementBlock("option", {
                key: j,
                value: j
              }, _toDisplayString(j), 9, _hoisted_25))
            }), 128))
          ], 2), [
            [_vModelSelect, _ctx.form.jobFunction]
          ]),
          _createElementVNode("span", _hoisted_26, [
            _createVNode(_component_ph_caret_down, {
              size: 14,
              weight: "bold"
            })
          ])
        ]),
        (_ctx.showErrors && !_ctx.form.jobFunction)
          ? (_openBlock(), _createElementBlock("p", _hoisted_27, "This field is required."))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_28, [
        _hoisted_29,
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("span", _hoisted_31, [
            _createVNode(_component_ph_phone, {
              size: 16,
              weight: "fill"
            })
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.phone) = $event)),
            type: "tel",
            class: _normalizeClass(["sv2-input sv2-input--icon", { 'sv2-input--error': _ctx.showErrors && !_ctx.form.phone }]),
            placeholder: "+1 (555) 000-0000"
          }, null, 2), [
            [
              _vModelText,
              _ctx.form.phone,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        (_ctx.showErrors && !_ctx.form.phone)
          ? (_openBlock(), _createElementBlock("p", _hoisted_32, "This field is required."))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_33, [
        _hoisted_34,
        _createElementVNode("div", _hoisted_35, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.country) = $event)),
            class: _normalizeClass(["sv2-input", {
                            'sv2-select--placeholder': !_ctx.form.country,
                            'sv2-input--error': _ctx.showErrors && !_ctx.form.country
                        }])
          }, [
            _hoisted_36,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (c) => {
              return (_openBlock(), _createElementBlock("option", {
                key: c,
                value: c
              }, _toDisplayString(c), 9, _hoisted_37))
            }), 128))
          ], 2), [
            [_vModelSelect, _ctx.form.country]
          ]),
          _createElementVNode("span", _hoisted_38, [
            _createVNode(_component_ph_caret_down, {
              size: 14,
              weight: "bold"
            })
          ])
        ]),
        (_ctx.showErrors && !_ctx.form.country)
          ? (_openBlock(), _createElementBlock("p", _hoisted_39, "This field is required."))
          : _createCommentVNode("", true)
      ]),
      (_ctx.isUS)
        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
            _hoisted_41,
            _createElementVNode("div", _hoisted_42, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.state) = $event)),
                class: _normalizeClass(["sv2-input", {
                            'sv2-select--placeholder': !_ctx.form.state,
                            'sv2-input--error': _ctx.showErrors && !_ctx.form.state
                        }])
              }, [
                _hoisted_43,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usStates, (s) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: s,
                    value: s
                  }, _toDisplayString(s), 9, _hoisted_44))
                }), 128))
              ], 2), [
                [_vModelSelect, _ctx.form.state]
              ]),
              _createElementVNode("span", _hoisted_45, [
                _createVNode(_component_ph_caret_down, {
                  size: 14,
                  weight: "bold"
                })
              ])
            ]),
            (_ctx.showErrors && !_ctx.form.state)
              ? (_openBlock(), _createElementBlock("p", _hoisted_46, "This field is required."))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_47, [
      _createElementVNode("button", {
        class: "sv2-btn-primary",
        type: "button",
        disabled: _ctx.checking,
        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleNext && _ctx.handleNext(...args)))
      }, [
        (_ctx.checking)
          ? (_openBlock(), _createElementBlock("span", _hoisted_49))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(_ctx.checking ? 'Checking…' : 'Next') + " ", 1),
        (!_ctx.checking)
          ? (_openBlock(), _createBlock(_component_ph_arrow_right, {
              key: 1,
              size: 16,
              weight: "bold"
            }))
          : _createCommentVNode("", true)
      ], 8, _hoisted_48)
    ])
  ]))
}